import { createAction, props } from '@ngrx/store';
import { Organization } from '../../../api/models/organization';

export enum OrganizationActionTypes {
  READ_ALL = '[Organization] READ_ALL',
  READ_ALL_SUCCESS = '[Organization] READ_ALL_SUCCESS',
  READ_ALL_FAILED = '[Organization] READ_ALL_FAILED',
}

export const readAllOrganizations = createAction(OrganizationActionTypes.READ_ALL);

export const readAllOrganizationsSuccess = createAction(
  OrganizationActionTypes.READ_ALL_SUCCESS,
  props<{ organizations: Organization[] }>()
);
